import { Deployment } from '@/types/deployment';

const ADMIN_PORTAL_BASE = 'adminportal.proxibid.com';

export const getAdminPortalUrl = (deployment: Deployment): string => {
    if (deployment === Deployment.Prod) {
        return `https://${ADMIN_PORTAL_BASE}`;
    }

    // Dev, QA, Stage follow the pattern: {prefix}-adminportal.proxibid.com
    // Local falls back to dev
    const prefix = deployment === Deployment.Local ? 'dev' : deployment.replace('-seller', '');

    return `https://${prefix}-${ADMIN_PORTAL_BASE}`;
};
